import api from '../utils/api';

/**
 * Customer subscription payment — User-Routes.js + paymentSetup.service.js
 */
export const USER_SUBSCRIPTION_API = {
  status: '/user/subscription/status',
  plans: '/user/subscription/plans',
  addonPlans: '/user/subscription/addons/plans',
  planRequest: '/user/subscription/plan-request',
  selectPlan: '/user/subscription/select-plan',
  confirmPlanPayment: '/user/subscription/confirm-plan-payment',
  contractCheckout: '/user/subscription/contract-checkout',
  contractCheckoutInitiate: '/user/subscription/contract-checkout/initiate',
  contractCheckoutConfirm: '/user/subscription/contract-checkout/confirm',
  paymentHistory: '/user/payment-history',
};

/** GET — paymentContext: paymentFlow, redirectRoute, canAccessRobots, openContract, etc. */
export function fetchSubscriptionStatus() {
  return api.get(USER_SUBSCRIPTION_API.status);
}

/** GET — payment ledger with refund.status, refund.label, mandateRefundSummary in summary. */
export function fetchUserPaymentHistory(params = {}) {
  return api.get(USER_SUBSCRIPTION_API.paymentHistory, { params });
}

/** @deprecated Use fetchUserPaymentHistory */
export function fetchSubscriptionPayments(params) {
  return fetchUserPaymentHistory(params);
}

export function fetchSubscriptionCatalogPlans() {
  return api.get(USER_SUBSCRIPTION_API.plans);
}

export function fetchSubscriptionAddonPlans() {
  return api.get(USER_SUBSCRIPTION_API.addonPlans);
}

export function fetchMyPlanRequest() {
  return api.get(USER_SUBSCRIPTION_API.planRequest);
}

/** POST { subscriptionPlanId, commitmentMonths?, billingFlow? } */
export function selectSubscriptionPlan(body) {
  return api.post(USER_SUBSCRIPTION_API.selectPlan, body);
}

/** POST { razorpay_order_id, razorpay_payment_id, razorpay_signature } */
export function confirmSubscriptionPlanPayment(body) {
  return api.post(USER_SUBSCRIPTION_API.confirmPlanPayment, body);
}

/** GET ?contractId= optional */
export function fetchContractCheckout(params) {
  return api.get(USER_SUBSCRIPTION_API.contractCheckout, { params });
}

/** POST { contractId? } */
export function initiateContractCheckout(body = {}) {
  return api.post(USER_SUBSCRIPTION_API.contractCheckoutInitiate, body);
}

/** POST { razorpay_order_id, razorpay_payment_id, razorpay_signature } */
export function confirmContractCheckout(body) {
  return api.post(USER_SUBSCRIPTION_API.contractCheckoutConfirm, body);
}
